<template>
  <div id="course-group-chat-container" class="flex rounded-lg border-l border-b relative border-gray-200 bg-white flex-col shadow-lg course-group-chat-container">
    <div class="flex items-center space-x-2 justify-between border-b bg-white border-gray-200 px-3 pt-4 pb-3.5">
      <div class="flex select-none items-center space-x-3">
        <div class="bg-white rounded-full h-10 w-10 flex items-center justify-center border border-gray-200">
          <img class="w-5 h-5" src="../../../../../static/course/message-chat-circle.svg"/>
        </div>
        <div>
          <h6 class="font-semibold text-gray-700 font-poppins leading-none text-base">Course Chat</h6>
          <span v-if="!chat_is_enabled" class="text-xs leading-tight font-poppins text-gray-400 ">
            Only teachers can send messages.
          </span>
          <span v-if="chat_is_enabled && hasTeacherPermissionsInCourse" class="text-xs leading-tight font-poppins text-gray-400">
            Students can send messages.
          </span>
        </div>
      </div>
      <div>
        <v-dropdown v-if="hasTeacherPermissionsInCourse" placement="right">
        <template v-slot:button>
          <button class="hover:bg-gray-100 rounded-full w-8 h-8">
            <i class="fas fa-ellipsis-v cursor-pointer text-gray-500 w-full flex items-center justify-center text-base"></i>
          </button>
        </template>
        <template v-slot:content>
          <ul class="w-44">
            <li @click="toggleCourseChat" class="sample space-x-2 border-b border-gray-200 group px-2.5 py-2.5 rounded-t flex items-center w-full cursor-pointer hover:bg-gray-100">
              <i class="fa fa-users"></i>
              <span v-if="!chat_is_enabled" class="text-left" id="remove-chat-message-id">Allow Students</span>
              <span v-else class="text-left">Block Students</span>
            </li>
            <li class="sample group px-2.5 py-2.5 flex space-x-2 items-center w-full cursor-pointer hover:bg-gray-100" @click="clearAllMessages">
              <i class="fas fa-trash-alt ml-0.5"></i>
              <span class="text-left" id="remove-chat-message-id">Clear All Messages</span>
            </li>
          </ul>
        </template>
      </v-dropdown>
      </div>
    </div>
    <div ref="groupChatMessages" id="group-chat-messages" @scroll="scrollOnGroupChat" class="flex w-full relative flex-grow h-full mb-4 overflow-y-auto">
      <div v-if="show_component" class="w-full px-3">
        <div :id="`message-${message.id}`" v-for="(message, index) in messages" :key="index" class="w-full">
          <div v-if="index === 0" class="flex items-center w-full space-x-2 py-4 justify-center select-none">
            <span class="font-poppins text-xs text-gray-500">{{ message.created_at | day }}</span>
          </div>
          <div v-else-if="isDifferentDay(index)" class="flex items-center py-4 space-x-2 w-full justify-center select-none">
            <span class="font-poppins text-xs text-gray-500">{{ message.created_at | day }}</span>
          </div>
          <div>
            <div v-if="getProfile.id === message.user.id" class="py-2">
              <div v-if="!getTeachers(message.user.id)" class="flex justify-between items-center space-x-2">
                <div>
                  <span class="text-xs text-gray-400">{{ message.created_at | time }}</span>
                </div>
                <div class="flex items-center space-x-2">
                  <span class="font-poppins text-gray-700">{{ message.user.name }}</span>
                  <img :src="message.user.avatar_url" class="rounded-full w-7 h-7"/>
                </div>
              </div>
              <div v-else class="flex items-center justify-between space-x-2">
                <div>
                  <span class="text-xs text-gray-400">{{ message.created_at | time }}</span>
                </div>
                <div class="flex items-center space-x-2">
                  <span class="font-poppins text-gray-700">{{ message.user.name }} (Teacher)</span>
                  <img :src="message.user.avatar_url" class="rounded-full w-7 h-7"/>
                </div>
              </div>
            </div>
            <div v-else class="py-2">
              <div v-if="!getTeachers(message.user.id)" class="flex justify-between items-center space-x-2">
                <div class="flex items-center space-x-2">
                  <img :src="message.user.avatar_url" class="rounded-full w-7 h-7"/>
                  <span class="font-poppins text-gray-700">{{ message.user.name }}</span>
                </div>
                <div>
                  <span class="text-xs text-gray-400">{{ message.created_at | time }}</span>
                </div>
              </div>
              <div v-else class="flex items-center justify-between space-x-2">
               <div class="flex items-center space-x-2">
                <img :src="message.user.avatar_url" class="rounded-full w-7 h-7"/>
                <span class="font-poppins text-gray-700">{{ message.user.name }} (Teacher)</span>
               </div>
               <div>
                <span class="text-xs text-gray-400">{{ message.created_at | time }}</span>
               </div>
              </div>
            </div>
          </div>
          <div @mouseenter="hoverMessage(message.id)" @mouseleave="hovered = false" class="w-full relative">
            <div v-if="getProfile.id === message.user.id" class="flex justify-end space-x-2 items-center">
              <button title="Delete" v-if="hasTeacherPermissionsInCourse && message.id === hovered" @click="deleteChatMessage(message.id)" class="w-7 h-7 rounded-full hover:bg-gray-100">
                <i class="fas text-xs fa-trash-alt cursor-pointer text-red-500"></i>
              </button>
              <div v-html="message.content" class="message-container break-words rounded-tr-none rounded-tl-xl rounded-b-xl px-3 py-2 text-white font-poppins w-10/12">
              </div>
            </div>
            <div v-else class="flex justify-start items-center space-x-2">
              <div v-html="message.content" class="bg-gray-100 break-words rounded-tl-none rounded-tr-xl rounded-b-xl px-3 py-2 text-gray-700 font-poppins w-10/12">
              </div>
              <div class="flex flex-col">
                <button title="Delete" v-if="hasTeacherPermissionsInCourse && message.id === hovered" @click="deleteChatMessage(message.id)" class="w-7 h-7 rounded-full hover:bg-gray-100">
                  <i class="fas text-xs fa-trash-alt cursor-pointer text-red-500"></i>
                </button>
              </div>
              
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col w-full h-full items-center justify-center">
        <pl-spinner class="flex justify-center" />
      </div>
    </div>
    <div class="flex w-full justify-between items-center space-x-2 px-3 pb-3.5">
      <div v-if="long_message" class="text-pinky ml-3 text-left">
        This message is too long
      </div>
      <div class="flex w-full justify-between items-center">
        <textbox
          class="rounded border placeholder:text-gray-100 h-16 max-h-14 w-10/12 focus-within:border-primary"
          placeholder="Leave a message"
          :maxHeight="56"
          v-model="chat_message"
          theme="muted-focus"
          @enter="sendChatMessage"
          :showSubmitButton="false"
          :fillRemaining="true"
          :focusOnMounted="true"
          :enableShiftEnter="true"
          :allowEmoji="true"
          :chatIsEnabled="hasTeacherPermissionsInCourse ? true : chat_is_enabled"
          :disabled="(!hasTeacherPermissionsInCourse && !chat_is_enabled) || getCourseDetail.is_sample === true"
        />
        <div class="w-10">
          <button @click="sendChatMessage" :disabled="chat_message.trim() === ''" title="Send Message" class="message-container text-white flex justify-center items-center rounded-full h-9 w-9">
            <img class="w-4 h-4" src="../../../../../static/course/send_message.svg"/>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import Textbox from 'components/textbox.vue';
  import $ from 'jquery';
  import moment from 'moment';

  export default {
    data() {
      return {
        chat_message: '',
        hovered: false,
        page_number: 1,
        show_more_messages: true,
        loading_messages: false,
        messages: [],
        show_component: false,
        char_limit: 40000, // same as slack
        sending_message: false,
      };
    },
    filters: {
      date: function (value) {
        if (!value) return;
        let date = new Date(value);
        date =
          date.getDate() +
          ' ' +
          date.toLocaleString('default', { month: 'short' }) +
          ' ' +
          date.getFullYear() +
          ' ' +
          date.getHours() +
          ':' +
          date.getMinutes() +
          ':' +
          date.getSeconds();
        return date;
      },
      day: function (value) {
        if (!value) return;
        let date = new Date(value);

        let day = moment(date).format('MMMM D, YYYY');

        return day;
      },
      time: function (value) {
        if (!value) return;
        let date = new Date(value);
        //date = date.getHours() + ':' + date.getMinutes();

        let time = moment(date).format('HH:mm');
        return time;
      },
    },
    components: {
      Textbox,
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getCourses',
        'getCourseDetail',
        'getProfile',
        'getRoleInCourse',
      ]),
      long_message() {
        return this.chat_message.trim().length > this.char_limit;
      },
      can_send_message() {
        return !this.getCourseDetail.chat_is_enabled
          ? this.hasTeacherPermissionsInCourse
          : true;
      },
      send_message_disabled() {
        return this.hasTeacherPermissionsInCourse
          ? this.chat_message.trim() === ''
          : this.chat_message.trim() === '' ||
              !this.getCourseDetail.chat_is_enabled;
      },
      chat_is_enabled() {
        return this.getCourseDetail.chat_is_enabled;
      },
    },
    methods: {
      day(value) {
        if (!value) return;
        let date = new Date(value);

        let day = moment(date).format('MMMM D, YYYY');

        return day;
      },
      isDifferentDay(index) {
        const currentMessageDate = this.day(this.messages[index].created_at);
        const previousMessageDate = this.day(
          this.messages[index - 1].created_at
        );

        if (currentMessageDate > previousMessageDate) {
          return true;
        }
      },
      toggleCourseChat() {
        this.$store.dispatch('toggleCourseChat', {
          courseID: this.getCourseDetail.id,
        });
      },
      getTeachers(userID) {
        const user = this.getCourseDetail.users.find((u) => u.id === userID);
        if (user && user.subscription.role !== 'student') {
          return true;
        }
        return false;
      },
      hoverMessage(id) {
        this.hovered = id;
      },
      isVisible(element, container) {
        const { bottom, height, top } = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        return top <= containerRect.top
          ? containerRect.top - top <= height
          : bottom - containerRect.bottom <= height;
      },
      urlify(text) {
        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        //var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url, b, c) {
          var url2 = c == 'www.' ? 'http://' + url : url;
          return '<a href="' + url2 + '" target="_blank">' + url + '</a>';
        });
      },
      sendChatMessage() {
        if (
          this.chat_message.trim() !== '' &&
          !this.sending_message &&
          this.getCourseDetail.is_sample === false
        ) {
          this.sending_message = true;
          let message_with_link = this.urlify(this.chat_message);
          this.$store
            .dispatch('sendChatMessage', {
              courseID: this.getCourseDetail.id,
              content: message_with_link, //this.chat_message,
            })
            .then(() => {
              this.chat_message = '';
              this.$emit('message_notifications_val', 0);
              this.scrollToEnd();
            })
            .finally(() => {
              this.sending_message = false;
            });
        }
      },
      deleteChatMessage(messageID) {
        this.$store.dispatch('deleteChatMessage', {
          courseID: this.getCourseDetail.id,
          id: messageID,
        });
      },
      clearAllMessages() {
        this.$store
          .dispatch('deleteAllChatMessages', {
            courseID: this.getCourseDetail.id,
          })
          .then(() => (this.messages = []));
      },
      scrollToEnd() {
        var content = this.$refs.groupChatMessages;
        content.scrollTop = content.scrollHeight;
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);
        return Math.floor(element.scrollTop) === 0;
      },
      elementHasReachedScrollStart(elementId) {
        const element = document.getElementById(elementId);
        return (
          element.scrollHeight - element.scrollTop === element.clientHeight
        );
      },
      scrollOnGroupChat() {
        if (
          this.elementHasReachedScrollEnd('group-chat-messages') &&
          this.show_more_messages &&
          !this.loading_messages
        ) {
          const last_message_id = this.messages.slice(0)[0].id;
          this.loading_messages = true;
          this.$store
            .dispatch('loadMoreMessages', {
              courseID: this.getCourseDetail.id,
              pageNumber: this.page_number,
            })
            .then(({ data }) => {
              if (data && data.length > 0) {
                this.messages.unshift(...data);
                this.page_number += 1;
              } else {
                this.show_more_messages = false;
              }
              if (data.length < 20) {
                this.show_more_messages = false;
              }
            })
            .catch((error) => console.log(error))
            .finally(() => {
              this.loading_messages = false;
              const last_message = document.getElementById(
                `message-${last_message_id}`
              );
              last_message.scrollIntoView();
            });
        } else if (this.elementHasReachedScrollStart('group-chat-messages')) {
          this.$emit('message_notifications_val', 0);
        }
      },
    },
    mounted() {
      this.$store
        .dispatch('loadMoreMessages', {
          courseID: this.getCourseDetail.id,
          pageNumber: this.page_number,
        })
        .then(({ data }) => {
          if (data && data.length > 0) {
            this.messages.unshift(...data);
            this.messages.reverse();
            this.page_number += 1;
            setTimeout(() => {
              this.scrollToEnd();
            });
          } else {
            this.show_more_messages = false;
          }
          if (data.length < 20) {
            this.show_more_messages = false;
          }
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.show_component = true;
          this.loading_messages = false;
        });
      $(document).on('click', (e) => {
        if (
          $(e.target).closest('#course-group-chat-container').length === 0 &&
          this.show_component &&
          e.target.id !== 'remove-chat-message-id' &&
          e.target.id !== 'overlay'
        ) {
          this.$emit('close');
        }
      });
      EventBus.$on('message-received', (message) => {
        this.messages.push(message);
        let element = null;
        let is_visible = false;
        const container = document.getElementById('group-chat-messages');
        if (this.messages.length >= 6) {
          element = document.getElementById(
            `message-${this.messages[this.messages.length - 6].id}`
          );
          is_visible = this.isVisible(element, container);
        }
        if (is_visible || !element) {
          setTimeout(() => {
            this.scrollToEnd();
            this.$emit('message_notifications_val', 0);
          });
        }
      });
      EventBus.$on('message-deleted', (id) => {
        const index = this.messages.findIndex((m) => m.id === id);
        if (index > -1) this.messages.splice(index, 1);
      });
      EventBus.$on('all-messages-deleted', (array) => {
        this.messages = array;
      });
    },
    beforeDestroy() {
      EventBus.$off('message-received');
      EventBus.$off('message-deleted');
      EventBus.$off('all-messages-deleted');
    },
  };
</script>
<style scoped>
  .course-group-chat-container {
    right: 20px;
    height: 60%;
    position: absolute;
    width: 375px;
    bottom: 90px;
    z-index: 2147483054;
  }

  .message-container {
    background: rgb(47,35,255);
    background: linear-gradient(338deg, rgba(47,35,255,1) 0%, rgba(0,185,255,1) 0%, rgba(107,212,224,1) 100%);
  }
</style>



// WEBPACK FOOTER //
// CourseChatBubble.vue?adca33e4